<template>
  <div class="hello">
    <Header></Header>

    <div class="content_s clearfix">
      <div class="news-list">
        <div ref="theme_top" :class="activeClass ? 'themeTop':''" >
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(au,index) in chanalsData" :key="index"   :label="au.chennel_name" :name="'chennel_'+au.id"></el-tab-pane>
          </el-tabs>
        </div>


        <div style="width:100%">
          <div >
            <el-row >
              <el-col :span="6"  v-for="(o, index) in articalData" :key="index"  @click.native="toArtical(o._uniquecode)" >
                <el-card :body-style="{ padding: '0px'}">
                  <div class="new-img"><img :src="o.thumb_image_url" class="image"></div>
                  <div class="shake">
                    <h3>{{o.title}}</h3>
                    <span class="bq-tip">{{o.chennel_name}}</span>
                  </div>
                </el-card>
              </el-col>
            </el-row>

            <!-- <el-row>
              <el-col :span="12" v-for="(o,k) in 2" :key="k">
                <el-card  :body-style="{ padding: '0px'}" class="card-2">
                  <img src="@/assets/images/alter-1.jpg" class="image">
                  <div class="shake2">
                    <h3>净利大跌21%，裁员超4000，市场为何却看涨阿里 </h3>
                    <span class="bq-tip">消费 </span>
                  </div>
                </el-card>
              </el-col>
            </el-row> -->
          </div>
        </div>




        <!-- <el-button type="primary"
                   @click="openFullScreen1"
                   v-loading.fullscreen.lock="fullscreenLoading">
          加载更多
        </el-button> -->

      </div>

    </div>


    <bbottom></bbottom>
  </div>
</template>

<script>

  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'News',
    data() {
      return {
        activeName: 'chennel_1',
        data: ['1', '2', '3', '4'],
        msg: 'shuiahuiah',
        currentDate: new Date(),

        listData: [
          {
            title: "榜单显示，中国中国以328973兆瓦高居榜首，而排在第二名的美国为132738兆瓦，还不到中国的一半。马斯",
            time: "2021-08-09",
          },
          {
            title: "【#成品油价或迎年内第九涨#，#92号汽油或进入9元时代#】5月30日24时，国内成品油将开启新一轮调价窗口。综合多家机构预测，成品油零售价将迎来年内第9次上调。 今年以来，国内成品油价格已进行了九轮调整，若本轮油价上调幅度最终超0.3元/升",
            time: "2021-08-09",
          },
          {
            title: "【#华为余承东称核心技术不能被卡脖子#，世界上没有后悔药】余承东出席2022粤港澳车展时表示：我们在核心领域不能被卡脖子，“我如果早些年搞半导体制造，也不会有今天这么糟糕的结局。",
            time: "2021-08-09",
          },

        ],
        // 小栏目频道
        chanalsData:[],
         // 文章列表
        articalData: [],
        activeClass: 0,

      }
    },

    props: {},
    created(){
      this.getChennelInfo()
      this. getContentInfo()
    },

    //页面初始化
    computed: {
      seamlessScrollOption() {
        return {
          step: 0.3, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    mounted(){
      window.addEventListener('scroll',this.thmem_move_top)
    },

    //页面加载后执行方法
    methods: {

      //跳转文章页面
      toArtical(_uniquecode){
        var routeInfo = this.$router.resolve({path:'/article/'+_uniquecode});
        window.open(routeInfo.href, '_blank');
      },
     // 获取文章主要内容
      getContentInfo(typeid=0){
        if (typeid==1){ typeid=0}
        var config = {
          method: 'GET',
          url: '/api/v1/artical/list/'+typeid,
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.$data.articalData = res.data
          console.log('请求成功')
        }).catch(error=>{
          console.log('请求失败')
        })
      },

      getChennelInfo()
      {
          var config = {
            method: 'GET',
            url: '/api/v1/chennel/list',
            headers: { 
                'Content-Type': 'application/json'
            }
          };
            
          this.$axios(config).then(res=>{

            this.$data.chanalsData = res.data
             console.log('请求成功')
          }).catch(error=>{
            console.log('请求失败')
          })

      },

      submit_data() {
        // this.$router.push('/collect')
      },
      handleClick(tab, event) {
        var typeid = tab.name.split('_')[1]
        this.getContentInfo( typeid )
      },
      thmem_move_top(newValue, oldValue) {
        let themeTop = this.$refs.theme_top;
        //浏览器兼容
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

        if (scrollTop > 30) {
          this.$data.activeClass= 1
        }
        else{
            this.$data.activeClass= 0
        }
      
      },

    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>

<style scoped>
body{

}
  .themeTop{
    position: fixed;
    /* display: left; */
    top:130px;
    /* left:0px; */
    width:100%;
    background: #fff;
    z-index:200;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .baomin {
    display: relative;
    width: 60%;
    height: 32px;
    border: white solid 2px;
    border-radius: 6px;
    text-align: center;
    color: white;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
  }

  .fonts_bao {
  }

  .hello {
    color: rgb(58, 2, 2);
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image{
  width: 108%;
  display: block;
  position: relative;
  top: -6px;
  left: -6px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }



  /*资讯列表*/
  .news-list {
    width: 100%;
    padding: 20px 0px;
    min-height: 800px;
  }

  .el-tabs {
    width: 100%;
  }

  .el-tabs__header {
    margin-bottom: 30px !important;
  }

  .el-card {
    margin: 16px 8px;
    cursor: pointer;
  }

    .el-card h3 {
      margin: 10px auto;
      padding: 0px 10px;
      font-size: 16px;
      line-height: 24px;
      height: 48px;
      overflow: hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
    }

  .bq-tip {
    margin: 0px 0px 20px;
    padding: 0px 10px;
    font-size: 12px;
    line-height: 18px;
    color: #bd0c16;
    display: block;
  }

  .el-button--primary {
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    font-size: 18px;
    color: #999;
    display: block;
    margin: 35px auto;
  }

  .tl-banner img {
    width: 100%;
    display: block;
  }
  /***/
  .r-gs1 {
    width: 100%;
    margin: 20px auto 0px;
  }

    .r-gs1 img {
      border-radius: 6px;
      display: block;
    }



  .el-icon-alarm-clock, .el-icon-connection, .el-icon-reading, .el-icon-trophy {
    margin-right: 3px;
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 118px;
    height: 40px;
    color: #ffffff;
    font-size: 16px;
    margin-top: 10px;
  }

  .el-card {
    transition: 3s;
  }

    .el-card:hover .shake {
      cursor: pointer;
      transform: translateY(10px);
      transition: all .3s ease-in;
    }

  .card-2 {
    position: relative;
  }

  .el-card:hover img {
  }

  .shake2 {
    cursor: pointer;
    position: absolute;
    bottom: 0px;
    left: 0px;
    color: #fff;
    width: 100%;
    height: 100px;
  }

    .shake2 h3 {
      opacity: 1;
      padding: 0px 20px 0px;
      font-size: 20px;
    }

  .card-2:hover .shake2 {
    transform: translateY(10px);
    transition: all .3s ease-in;
  }

  .card-2 .bq-tip {
    padding: 2px 10px;
    display: inline-block;
    background-color: #fff;
    border-radius: 6px;
    margin: 0px 0px 0px 20px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }
     .new-img {
    height: 170px;
    overflow: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/components/Atrcallist.vue